import { render, staticRenderFns } from "./DesignPreviewModal.vue?vue&type=template&id=64fdc378&"
import script from "./DesignPreviewModal.vue?vue&type=script&lang=js&"
export * from "./DesignPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports